import { z } from "zod";

export const ZYtterveggerOverTerrengSchema = z.object({
  // 11
  isActive: z.boolean().default(false),
  tekst: z.string(),
  bindingsverkMedLuftetKledning: z.object({
    // 11.1
    isActive: z.boolean().default(false),
    tekst: z.string(),
    staendeOgLiggendeTrekledning: z.object({
      // 11.1.1
      isActive: z.boolean().default(false),
      tekst: z.string(),
    }),
    platekledning: z.object({
      // 11.1.2
      isActive: z.boolean().default(false),
      tekst: z.string(),
    }),
    ventilertePussplater: z.object({
      // 11.1.3
      isActive: z.boolean().default(false),
      tekst: z.string(),
    }),
    teglforblending: z.object({
      // 11.1.4
      isActive: z.boolean().default(false),
      tekst: z.string(),
    }),
  }),
  massivtreElementer: z.object({
    // 11.2
    isActive: z.boolean().default(false),
    tekst: z.string(),
    utenpaliggendeIsolasjon: z.object({
      // 11.2.1
      isActive: z.boolean().default(false),
      tekst: z.string(),
      staendeOgLiggendeTrekledning: z.object({
        // 11.2.1.1
        isActive: z.boolean().default(false),
        tekst: z.string(),
      }),
      platekledning: z.object({
        // 11.2.1.2
        isActive: z.boolean().default(false),
        tekst: z.string(),
      }),
      ventilertePussplater: z.object({
        // 11.2.1.3
        isActive: z.boolean().default(false),
        tekst: z.string(),
      }),
      teglforblending: z.object({
        // 11.2.1.4
        isActive: z.boolean().default(false),
        tekst: z.string(),
      }),
    }),
    paforetBindingsverk: z.object({
      // 11.2.2
      isActive: z.boolean().default(false),
      tekst: z.string(),
      staendeOgLiggendeTrekledning: z.object({
        // 11.2.2.1
        isActive: z.boolean().default(false),
        tekst: z.string(),
      }),
      platekledning: z.object({
        // 11.2.2.2
        isActive: z.boolean().default(false),
        tekst: z.string(),
      }),
      ventilertePussplater: z.object({
        // 11.2.2.3
        isActive: z.boolean().default(false),
        tekst: z.string(),
      }),
      teglforblending: z.object({
        // 11.2.2.4
        isActive: z.boolean().default(false),
        tekst: z.string(),
      }),
    }),
  }),
  utvendigIsolertBetongvegg: z.object({
    // 11.3
    isActive: z.boolean().default(false),
    tekst: z.string(),
    utenpaliggendeIsolasjon: z.object({
      // 11.3.1
      isActive: z.boolean().default(false),
      tekst: z.string(),
      staendeOgLiggendeTrekledning: z.object({
        // 11.3.1.1
        isActive: z.boolean().default(false),
        tekst: z.string(),
      }),
      platekledning: z.object({
        // 11.3.1.2
        isActive: z.boolean().default(false),
        tekst: z.string(),
      }),
      ventilertePussplater: z.object({
        // 11.3.1.3
        isActive: z.boolean().default(false),
        tekst: z.string(),
      }),
      teglforblending: z.object({
        // 11.3.1.4
        isActive: z.boolean().default(false),
        tekst: z.string(),
      }),
    }),
    paforetBindingsverk: z.object({
      // 11.3.2
      isActive: z.boolean().default(false),
      tekst: z.string(),
      staendeOgLiggendeTrekledning: z.object({
        // 11.3.2.1
        isActive: z.boolean().default(false),
        tekst: z.string(),
      }),
      platekledning: z.object({
        // 11.3.2.2
        isActive: z.boolean().default(false),
        tekst: z.string(),
      }),
      ventilertePussplater: z.object({
        // 11.3.2.3
        isActive: z.boolean().default(false),
        tekst: z.string(),
      }),
      teglforblending: z.object({
        // 11.3.2.4
        isActive: z.boolean().default(false),
        tekst: z.string(),
      }),
    }),
  }),
  veggAvMur: z.object({
    // 11.4
    isActive: z.boolean().default(false),
    tekst: z.string(),
  }),
  prefabrikkerteVeggelementer: z.object({
    // 11.5
    isActive: z.boolean().default(false),
    tekst: z.string(),
    letteSandwichElementer: z.object({
      // 11.5.1
      isActive: z.boolean().default(false),
      tekst: z.string(),
      stalsandwich: z.object({
        // 11.5.1.1
        isActive: z.boolean().default(false),
        tekst: z.string(),
      }),
      bindingsverk: z.object({
        // 11.5.1.2
        isActive: z.boolean().default(false),
        tekst: z.string(),
      }),
    }),
    tungeSandwichElementer: z.object({
      // 11.5.2
      isActive: z.boolean().default(false),
      tekst: z.string(),
      betongsandwich: z.object({
        // 11.5.2.1
        isActive: z.boolean().default(false),
        tekst: z.string(),
      }),
      lettklinker: z.object({
        // 11.5.2.2
        isActive: z.boolean().default(false),
        tekst: z.string(),
      }),
    }),
  }),
  murverk: z.object({
    // 11.6
    isActive: z.boolean().default(false),
    tekst: z.string(),
  }),
  pahengsvegger: z.object({
    // 11.7
    isActive: z.boolean().default(false),
    tekst: z.string(),
  }),
});

export type IYtterveggerOverTerrengSchema = z.infer<typeof ZYtterveggerOverTerrengSchema>;
